export default "__VITE_ASSET__Xqy1GhJS__"